import { defineNuxtPlugin } from '#app/nuxt'
import { LazyChargemapAlert, LazyChargemapB2BBadge, LazyChargemapB2BBreadcrumbs, LazyChargemapB2BButton, LazyChargemapB2BCard, LazyChargemapB2BDrawerHeader, LazyChargemapB2BDropZone, LazyChargemapB2BLink, LazyChargemapB2BModal, LazyChargemapB2BPagination, LazyChargemapB2BPlannerCalendar, LazyChargemapBulkActionBar, LazyChargemapCardRadioButton, LazyChargemapCheckboxInput, LazyChargemapConfirmModal, LazyChargemapDatePicker, LazyChargemapDropdown, LazyChargemapFilterButton, LazyChargemapIconModal, LazyChargemapInput, LazyChargemapLoader, LazyChargemapMinimalSteps, LazyChargemapNumberButton, LazyChargemapNumberInput, LazyChargemapPage, LazyChargemapProgressStep, LazyChargemapRadioButton, LazyChargemapSelect, LazyChargemapSlider, LazyChargemapSliderV2, LazyChargemapSwitch, LazyChargemapTag, LazyChargemapTitle, LazyChargemapTooltip, LazyChargemapMenu, LazyChargemapMenuLink, LazyChargemapMenuSection, LazyChargemapSubMenu, LazyChargemapTable, LazyChargemapTableCell, LazyChargemapTableColumn, LazyChargemapTableColumnOrder, LazyChargemapTableRow, LazyChargemapTableRowSkeleton, LazyChargemapDetailSection, LazyChargemapDetailSectionContainer, LazyChargemapDetailSectionLine, LazyChargemapFiltersContainer, LazyCheckboxFilter, LazyFiltersSection, LazyRadioFilter, LazyRangeFilter, LazyChargemapLogo, LazyChargemapPass, LazyCommunityBlue, LazyCommunityWhite, LazyEmptyViewIllustration, LazyLogoBusiness, LazyLogoOps, LazyLogoPartners, LazyLogoPartnersMenu, LazyNoContribution, LazyNoContributionWithFilters, LazyPopupLocation, LazyPopupMaterial, LazyPopupPrice, LazyPopupSecurity, LazyBreadcrumbItem, LazyAppDownloadCta, LazyAppDownloadSection, LazyAuthWallDrawer, LazyB2CCheckbox, LazyB2CSwitch, LazyBoostCtaBanner, LazyChargemapAnnouncements, LazyChargemapB2CBadge, LazyChargemapB2CBadgeChip, LazyChargemapB2CButton, LazyChargemapB2CSlider, LazyChargemapB2CSwitch, LazyChargemapBreadcrumbs, LazyChargemapCta, LazyChargemapFooter, LazyChargemapFormInput, LazyChargemapMessageShort, LazyChargemapMessageTall, LazyChargemapNavigation, LazyChargemapPagination, LazyChargemapSearchDropdown, LazyChargemapSegmentedButton, LazyChargemapSeparatedLabel, LazyChargingSession, LazyDiscoverChargemapPass, LazyEmptyView, LazyExpenseReport, LazyFooterMap, LazyJoinEvDrivers, LazyLanguageModal, LazyMonthlyCharges, LazySegmentedButtonOption, LazySelectMenu, LazySelectMenuItem, LazyStepByStep, LazySuperPartnerLabel, LazyFooterBottomLine, LazyFooterCityFooter, LazyFooterCityList, LazyFooterDidomi, LazyFooterLocalesList, LazyFooterMobileApps, LazyFooterNetworkFooter, LazyFooterNetworkList, LazyFooterPrimaryFooter, LazyFooterSecondaryFooter, LazyFooterSocials, LazyFormInputSearch, LazyFormInputSimple, LazyFormLabelledInput, LazyFormSwitchSelector, LazyMapAddressSearch, LazyMapFilter, LazyMapFiltersDiscountGroup, LazyMapFiltersPowerSelector, LazyMapFiltersSelectorGrid, LazyMapRoutePanelCheckpointInput, LazyMapRoutePanelMobileAppBanner, LazyMapRoutePanelRouteCreator, LazyNavigationMenuButton, LazySimulationBatteryLevel, LazySimulationConnectorCellPicker, LazySimulationConnectorsList, LazySimulationCostLine, LazySimulationLegalBlock, LazySimulationPriceStructure, LazySimulationResultsDisplay, LazySimulationResultsReducedDisplay, LazySimulationResultsSummary, LazySimulationUserSettings, LazySimulationVehicleCell, LazySimulationVehiclesList, LazyVehiclesDeletionView, LazyVehiclesFormView, LazyVehiclesSelectorView, LazyEmptyTableIcon, LazyInfoBanner, LazyLoader, LazyModerationTable, LazyModerationTableLine, LazyPagination, LazySearch, LazySelect, LazyDrawerCloseButton, LazyDrawerTitleBar, LazyBaseButton, LazyBasePagination, LazyBottomSheet, LazyChargemapAccordion, LazyChargemapBadge, LazyChargemapBaseBadgeChip, LazyChargemapCaption, LazyChargemapCard, LazyChargemapDetailInfoLine, LazyChargemapDrawer, LazyChargemapDrawerContainer, LazyChargemapFeedbackContainer, LazyChargemapLabel, LazyChargemapMap, LazyChargemapMapDrawer, LazyChargemapMapFiltersContainer, LazyChargemapMessage, LazyChargemapModal, LazyChargemapPicturePreview, LazyChargemapSkeletonLoader, LazyChargemapTabs, LazyConnectorsCarousel, LazyFileUploader, LazyImageCropper, LazyImageUploader, LazyMappyPoolPreview, LazyModalBottomSheet, LazySimplifiedConnectorsCarousel, LazyChargemapFeedbacksFilter, LazyChargemapGeneralMood, LazyFeedback, LazyFeedbackCard, LazyFeedbackRating, LazyFeedbacksNotFound, LazyCheckin, LazyCheckinContent, LazyCheckinHeader, LazyCheckinInProgressContent, LazyCheckinInProgressHeader, LazyComment, LazyCommentContent, LazyCommentHeader, LazyCommentResponse, LazyReport, LazyReportContent, LazyReportHeader, LazyLeafletRoutingMachine, LazyMapKey, LazyMapZoom, LazyPhotoPanel, LazyPoolChargeSimulator, LazyPoolListPanel, LazyPoolPrices, LazyRoutePanel, LazyPhotosPhotoDisplay, LazyPoolListPreviewCard, LazyPoolListPreviewCardHeader, LazyPreviewAssistanceTab, LazyPreviewConnectorsTab, LazyPreviewFeedbackTab, LazyPreviewInfoTab, LazyPreviewAssistanceAskForHelp, LazyPreviewAssistanceCompatibleWithPass, LazyPreviewAssistanceOrderPass, LazyPreviewAssistanceOwnerInfos, LazyPreviewInfoDrawerInfoAccess, LazyPreviewInfoDrawerInfoAmenities, LazyPreviewInfoDrawerInfoCard, LazyPreviewInfoDrawerInfoDescription, LazyPreviewInfoDrawerInfoHours, LazyPreviewInfoDrawerInfoNetwork, LazyPreviewInfoDrawerOtherInfo, LazyPreviewHeaderActionsMenu, LazyPreviewHeaderDrawerBadges, LazyPreviewHeaderDrawerHeader, LazyPreviewHeaderDrawerHeaderFree, LazyPreviewHeaderDrawerHeaderPremium, LazyPreviewHeaderDrawerMessage, LazyPreviewHeaderDrawerPicturesContainer, LazyPreviewHeaderDrawerRating, LazyPreviewHeaderDrawerReliabilityBar, LazyPreviewHeaderDrawerTitle, LazyConnectorCard, LazyConnectorLine, LazyPoolChargemapCompatibility, LazyPoolPricesModal, LazyFilterRatingRange, LazyPoolRating, LazyRatingCriteriaPopup, LazyRatingDetailPopup, LazyRatingDetailPopupItem, LazyRatingInfosPopup, LazyChargemapSpinningLoader, LazyIconAcademicCap, LazyIconAdjustmentsHorizontal, LazyIconAdjustmentsVertical, LazyIconAirport, LazyIconAirportAlt, LazyIconAnnotation, LazyIconArchive, LazyIconArchiveBox, LazyIconArchiveBoxArrowDown, LazyIconArchiveBoxXMark, LazyIconArrayReturnRight, LazyIconArrowCircleDown, LazyIconArrowCircleLeft, LazyIconArrowCircleRight, LazyIconArrowCircleUp, LazyIconArrowDown, LazyIconArrowDownCircle, LazyIconArrowDownLeft, LazyIconArrowDownOnSquare, LazyIconArrowDownOnSquareStack, LazyIconArrowDownRight, LazyIconArrowDownTray, LazyIconArrowLeft, LazyIconArrowLeftCircle, LazyIconArrowLeftEndOnRectangle, LazyIconArrowLeftStartOnRectangle, LazyIconArrowLongDown, LazyIconArrowLongLeft, LazyIconArrowLongRight, LazyIconArrowLongUp, LazyIconArrowNarrowDouble, LazyIconArrowNarrowDown, LazyIconArrowNarrowLeft, LazyIconArrowNarrowRight, LazyIconArrowNarrowShortDown, LazyIconArrowNarrowShortUp, LazyIconArrowNarrowUp, LazyIconArrowPath, LazyIconArrowPathRoundedSquare, LazyIconArrowRight, LazyIconArrowRightCircle, LazyIconArrowRightEndOnRectangle, LazyIconArrowRightStartOnRectangle, LazyIconArrowSmallDown, LazyIconArrowSmallLeft, LazyIconArrowSmallRight, LazyIconArrowSmallRightLeft, LazyIconArrowSmallUp, LazyIconArrowSmallUpDown, LazyIconArrowTopRightOnSquare, LazyIconArrowTrendingDown, LazyIconArrowTrendingUp, LazyIconArrowUp, LazyIconArrowUpCircle, LazyIconArrowUpLeft, LazyIconArrowUpOnSquare, LazyIconArrowUpOnSquareStack, LazyIconArrowUpRight, LazyIconArrowUpTray, LazyIconArrowUturnDown, LazyIconArrowUturnLeft, LazyIconArrowUturnRight, LazyIconArrowUturnUp, LazyIconArrowsExpand, LazyIconArrowsPointingIn, LazyIconArrowsPointingOut, LazyIconArrowsRightLeft, LazyIconArrowsUpDown, LazyIconAsterisk, LazyIconAtSymbol, LazyIconAutocharge, LazyIconB2BParking, LazyIconB2BPlus, LazyIconB2BTicket, LazyIconBabyChanging, LazyIconBackspace, LazyIconBackward, LazyIconBadgeCheck, LazyIconBan, LazyIconBankNotes, LazyIconBar3CenterLeft, LazyIconBars2, LazyIconBars3, LazyIconBars3BottomLeft, LazyIconBars3BottomRight, LazyIconBars3CenterLeft, LazyIconBars4, LazyIconBarsArrowDown, LazyIconBarsArrowUp, LazyIconBattery0, LazyIconBattery100, LazyIconBattery50, LazyIconBatteryHorizontal0, LazyIconBatteryHorizontal10, LazyIconBatteryHorizontal100, LazyIconBatteryHorizontal25, LazyIconBatteryHorizontal33, LazyIconBatteryHorizontal50, LazyIconBatteryHorizontal60, LazyIconBatteryHorizontal80, LazyIconBatteryVertical0, LazyIconBatteryVertical10, LazyIconBatteryVertical100, LazyIconBatteryVertical25, LazyIconBatteryVertical33, LazyIconBatteryVertical50, LazyIconBatteryVertical60, LazyIconBatteryVertical80, LazyIconBeaker, LazyIconBell, LazyIconBellAlert, LazyIconBellSlash, LazyIconBellSnooze, LazyIconBolt, LazyIconBoltSlash, LazyIconBookOpen, LazyIconBookmark, LazyIconBookmarkAlt, LazyIconBookmarkSlash, LazyIconBookmarkSquare, LazyIconBriefcase, LazyIconBugAnt, LazyIconBuildingLibrary, LazyIconBuildingOffice, LazyIconBuildingOffice2, LazyIconBuildingStorefront, LazyIconBurger, LazyIconCaddie, LazyIconCake, LazyIconCalculator, LazyIconCalendar, LazyIconCalendarDays, LazyIconCamera, LazyIconCameraPlus, LazyIconCampside, LazyIconCar, LazyIconCash, LazyIconChargeStatusCharging, LazyIconChargeStatusPluggedCable, LazyIconChargemap, LazyIconChargemapBoost, LazyIconChargemapBusiness, LazyIconChargemapPartners, LazyIconChargemapPass, LazyIconChargesAtHome, LazyIconChargingBadge, LazyIconChargingBadgeUnknown, LazyIconChargingStatusIcons, LazyIconChartBar, LazyIconChartBarSquare, LazyIconChartPie, LazyIconChartSquareBar, LazyIconChat, LazyIconChatAlt, LazyIconChatAlt2, LazyIconChatBubbleBottomCenter, LazyIconChatBubbleBottomCenterText, LazyIconChatBubbleLeft, LazyIconChatBubbleLeftEllipsis, LazyIconChatBubbleLeftRight, LazyIconChatBubbleOvalLeft, LazyIconChatBubbleOvalLeftEllipsis, LazyIconCheck, LazyIconCheckBadge, LazyIconCheckCircle, LazyIconChevronDoubleDown, LazyIconChevronDoubleLeft, LazyIconChevronDoubleRight, LazyIconChevronDoubleUp, LazyIconChevronDown, LazyIconChevronLeft, LazyIconChevronRight, LazyIconChevronUp, LazyIconChevronUpDown, LazyIconChip, LazyIconChurch, LazyIconCircleStack, LazyIconClipboard, LazyIconClipboardCheck, LazyIconClipboardCopy, LazyIconClipboardDocument, LazyIconClipboardDocumentCheck, LazyIconClipboardDocumentList, LazyIconClipboardList, LazyIconClock, LazyIconClose, LazyIconCloud, LazyIconCloudArrowDown, LazyIconCloudArrowUp, LazyIconCloudDownload, LazyIconCloudUpload, LazyIconCo2, LazyIconCode, LazyIconCodeBracket, LazyIconCodeBracketSquare, LazyIconCog, LazyIconCog6Tooth, LazyIconCog8Tooth, LazyIconCollection, LazyIconColorSwatch, LazyIconCommandLine, LazyIconComputerDesktop, LazyIconCornerUpLeft, LazyIconCpuChip, LazyIconCreditCard, LazyIconCross, LazyIconCube, LazyIconCubeTransparent, LazyIconCurrencyBangladeshi, LazyIconCurrencyDollar, LazyIconCurrencyEuro, LazyIconCurrencyPound, LazyIconCurrencyRupee, LazyIconCurrencyYen, LazyIconCursorArrowRays, LazyIconCursorArrowRipple, LazyIconCursorClick, LazyIconDashboard, LazyIconDatabase, LazyIconDeliveryPoint, LazyIconDesktopComputer, LazyIconDeviceMobile, LazyIconDevicePhoneMobile, LazyIconDeviceTablet, LazyIconDocument, LazyIconDocumentAdd, LazyIconDocumentArrowDown, LazyIconDocumentArrowUp, LazyIconDocumentChartBar, LazyIconDocumentCheck, LazyIconDocumentDownload, LazyIconDocumentDuplicate, LazyIconDocumentInvoice, LazyIconDocumentMagnifyingGlass, LazyIconDocumentMinus, LazyIconDocumentPlus, LazyIconDocumentRemove, LazyIconDocumentReport, LazyIconDocumentSearch, LazyIconDocumentText, LazyIconDollar, LazyIconDoor, LazyIconDot, LazyIconDotsCircleHorizontal, LazyIconDotsHorizontal, LazyIconDotsVertical, LazyIconDownload, LazyIconDrinks, LazyIconDrop, LazyIconDropdown, LazyIconDuplicate, LazyIconEditWhite, LazyIconElectricOutlet, LazyIconEllipsisHorizontal, LazyIconEllipsisHorizontalCircle, LazyIconEllipsisVertical, LazyIconEmojiHappy, LazyIconEmojiSad, LazyIconEnter, LazyIconEnvelope, LazyIconEnvelopeOpen, LazyIconError, LazyIconEuro, LazyIconExclamation, LazyIconExclamationCircle, LazyIconExclamationTriangle, LazyIconExternalLink, LazyIconEye, LazyIconEyeClosed, LazyIconEyeDropper, LazyIconEyeOff, LazyIconEyeSlash, LazyIconFaceFrown, LazyIconFaceSmile, LazyIconFacebook, LazyIconFastForward, LazyIconFilm, LazyIconFilter, LazyIconFingerPrint, LazyIconFire, LazyIconFlag, LazyIconFlagCheckLeft, LazyIconFlagCheckRight, LazyIconFlagRectangleAdd, LazyIconFlagRectangleLeft, LazyIconFlagRectangleRight, LazyIconFlagTriangleAdd, LazyIconFlashliteOff, LazyIconFlashliteOn, LazyIconFleet, LazyIconFolder, LazyIconFolderAdd, LazyIconFolderArrowDown, LazyIconFolderDownload, LazyIconFolderMinus, LazyIconFolderOpen, LazyIconFolderPlus, LazyIconFolderRemove, LazyIconForward, LazyIconFunnel, LazyIconGasStation, LazyIconGif, LazyIconGift, LazyIconGiftTop, LazyIconGlobe, LazyIconGlobeAlt, LazyIconGlobeAmericas, LazyIconGlobeAsiaAustralia, LazyIconGlobeEuropeAfrica, LazyIconHand, LazyIconHandRaised, LazyIconHandThumbDown, LazyIconHandThumbUp, LazyIconHashtag, LazyIconHeart, LazyIconHelp, LazyIconHeroicShoppingBag, LazyIconHighway, LazyIconHome, LazyIconHomeModern, LazyIconHospital, LazyIconIdentification, LazyIconInbox, LazyIconInboxArrowDown, LazyIconInboxIn, LazyIconInboxStack, LazyIconInfo, LazyIconInfoCircle, LazyIconInformationCircle, LazyIconInstagram, LazyIconKey, LazyIconLanguage, LazyIconLaunchGps, LazyIconLibrary, LazyIconLifebuoy, LazyIconLightBulb, LazyIconLightningBolt, LazyIconLightningBoltFast, LazyIconLightningBoltVeryFast, LazyIconLink, LazyIconLinkedin, LazyIconListBullet, LazyIconLoader, LazyIconLocationMarker, LazyIconLockClosed, LazyIconLockOpen, LazyIconLodging, LazyIconLogin, LazyIconLogout, LazyIconMagnifyingGlass, LazyIconMagnifyingGlassCircle, LazyIconMagnifyingGlassMinus, LazyIconMagnifyingGlassPlus, LazyIconMail, LazyIconMailOpen, LazyIconMap, LazyIconMapPin, LazyIconMegaphone, LazyIconMenu, LazyIconMenuAlt1, LazyIconMenuAlt2, LazyIconMenuAlt3, LazyIconMenuAlt4, LazyIconMicrophone, LazyIconMinus, LazyIconMinusCircle, LazyIconMoneyCoins, LazyIconMoon, LazyIconMusicNote, LazyIconMusicalNote, LazyIconNewspaper, LazyIconNoPass, LazyIconNoSymbol, LazyIconNotificationCheckCircle, LazyIconNotificationExclamationCircle, LazyIconNotificationInfoCircle, LazyIconNotificationTrashCircle, LazyIconOfficeBuilding, LazyIconOrder, LazyIconPaintBrush, LazyIconPaperAirplane, LazyIconPaperClip, LazyIconPark, LazyIconParking, LazyIconPassActivated, LazyIconPassNotActivated, LazyIconPause, LazyIconPauseCircle, LazyIconPencil, LazyIconPencilAlt, LazyIconPencilSquare, LazyIconPerson, LazyIconPhone, LazyIconPhoneArrowDownLeft, LazyIconPhoneArrowUpRight, LazyIconPhoneIncoming, LazyIconPhoneMissedCall, LazyIconPhoneOutgoing, LazyIconPhoneXMark, LazyIconPhoto, LazyIconPhotograph, LazyIconPiggyBank, LazyIconPin, LazyIconPlay, LazyIconPlayCircle, LazyIconPlayPause, LazyIconPlug, LazyIconPlugAndCharge, LazyIconPluggedCar, LazyIconPlus, LazyIconPlusCircle, LazyIconPolygone, LazyIconPosition, LazyIconPower, LazyIconPresentationChartBar, LazyIconPresentationChartLine, LazyIconPrinter, LazyIconPublicRoad, LazyIconPuzzle, LazyIconPuzzlePiece, LazyIconQrcode, LazyIconQuestionMarkCircle, LazyIconQuestionMarkCircleB2B, LazyIconQueueList, LazyIconRadar, LazyIconRadio, LazyIconReceiptPercent, LazyIconReceiptRefund, LazyIconReceiptTax, LazyIconRectangleGroup, LazyIconRectangleStack, LazyIconRedOctogone, LazyIconRefresh, LazyIconReply, LazyIconRestaurant, LazyIconRestroom, LazyIconRewind, LazyIconRocketLaunch, LazyIconRocketLightning, LazyIconRoute, LazyIconRouteOff, LazyIconRss, LazyIconSave, LazyIconSaveAs, LazyIconScale, LazyIconScissors, LazyIconSearch, LazyIconSearchCircle, LazyIconSelector, LazyIconServer, LazyIconServerStack, LazyIconSettingsHorizontal, LazyIconSettingsVertical, LazyIconShare, LazyIconShareAlt, LazyIconShieldCheck, LazyIconShieldExclamation, LazyIconShop, LazyIconShoppingBag, LazyIconShoppingCart, LazyIconSignal, LazyIconSignalSlash, LazyIconSnacking, LazyIconSortAscending, LazyIconSortDescending, LazyIconSparkles, LazyIconSpeaker, LazyIconSpeakerWave, LazyIconSpeakerXMark, LazyIconSpeakerphone, LazyIconSpeakerphoneCircle, LazyIconSquare2Stack, LazyIconSquare3Stack3D, LazyIconSquares2x2, LazyIconSquaresPlus, LazyIconStar, LazyIconStarEmpty, LazyIconStarFull, LazyIconStarHalf, LazyIconStatusOffline, LazyIconStatusOnline, LazyIconStop, LazyIconStopCircle, LazyIconSuccess, LazyIconSun, LazyIconSuperPartner, LazyIconSupport, LazyIconSwatch, LazyIconSwitchHorizontal, LazyIconSwitchVertical, LazyIconTable, LazyIconTableCells, LazyIconTag, LazyIconTelepeage, LazyIconTemplate, LazyIconTerminal, LazyIconThumbDown, LazyIconThumbUp, LazyIconTicket, LazyIconTollBadge, LazyIconTopRightOnSquare, LazyIconTouristAttraction, LazyIconTrainStation, LazyIconTranslate, LazyIconTrash, LazyIconTrendingDown, LazyIconTrendingUp, LazyIconTriangleUp, LazyIconTrophy, LazyIconTruck, LazyIconTv, LazyIconTwitter, LazyIconUnlink, LazyIconUpload, LazyIconUser, LazyIconUserAdd, LazyIconUserCircle, LazyIconUserGroup, LazyIconUserMinus, LazyIconUserPlus, LazyIconUserRemove, LazyIconUsers, LazyIconVariable, LazyIconVideoCamera, LazyIconVideoCameraSlash, LazyIconViewBoards, LazyIconViewColumns, LazyIconViewGrid, LazyIconViewGridAdd, LazyIconViewList, LazyIconViewfinderCircle, LazyIconVolumeOff, LazyIconVolumeUp, LazyIconWallet, LazyIconWarning, LazyIconWifi, LazyIconWindow, LazyIconWorld, LazyIconWrench, LazyIconWrenchScrewdriver, LazyIconX, LazyIconXCircle, LazyIconXMark, LazyIconYoutube, LazyIconZoomIn, LazyIconZoomOut } from '#components'
const lazyGlobalComponents = [
  ["ChargemapAlert", LazyChargemapAlert],
["ChargemapB2BBadge", LazyChargemapB2BBadge],
["ChargemapB2BBreadcrumbs", LazyChargemapB2BBreadcrumbs],
["ChargemapB2BButton", LazyChargemapB2BButton],
["ChargemapB2BCard", LazyChargemapB2BCard],
["ChargemapB2BDrawerHeader", LazyChargemapB2BDrawerHeader],
["ChargemapB2BDropZone", LazyChargemapB2BDropZone],
["ChargemapB2BLink", LazyChargemapB2BLink],
["ChargemapB2BModal", LazyChargemapB2BModal],
["ChargemapB2BPagination", LazyChargemapB2BPagination],
["ChargemapB2BPlannerCalendar", LazyChargemapB2BPlannerCalendar],
["ChargemapBulkActionBar", LazyChargemapBulkActionBar],
["ChargemapCardRadioButton", LazyChargemapCardRadioButton],
["ChargemapCheckboxInput", LazyChargemapCheckboxInput],
["ChargemapConfirmModal", LazyChargemapConfirmModal],
["ChargemapDatePicker", LazyChargemapDatePicker],
["ChargemapDropdown", LazyChargemapDropdown],
["ChargemapFilterButton", LazyChargemapFilterButton],
["ChargemapIconModal", LazyChargemapIconModal],
["ChargemapInput", LazyChargemapInput],
["ChargemapLoader", LazyChargemapLoader],
["ChargemapMinimalSteps", LazyChargemapMinimalSteps],
["ChargemapNumberButton", LazyChargemapNumberButton],
["ChargemapNumberInput", LazyChargemapNumberInput],
["ChargemapPage", LazyChargemapPage],
["ChargemapProgressStep", LazyChargemapProgressStep],
["ChargemapRadioButton", LazyChargemapRadioButton],
["ChargemapSelect", LazyChargemapSelect],
["ChargemapSlider", LazyChargemapSlider],
["ChargemapSliderV2", LazyChargemapSliderV2],
["ChargemapSwitch", LazyChargemapSwitch],
["ChargemapTag", LazyChargemapTag],
["ChargemapTitle", LazyChargemapTitle],
["ChargemapTooltip", LazyChargemapTooltip],
["ChargemapMenu", LazyChargemapMenu],
["ChargemapMenuLink", LazyChargemapMenuLink],
["ChargemapMenuSection", LazyChargemapMenuSection],
["ChargemapSubMenu", LazyChargemapSubMenu],
["ChargemapTable", LazyChargemapTable],
["ChargemapTableCell", LazyChargemapTableCell],
["ChargemapTableColumn", LazyChargemapTableColumn],
["ChargemapTableColumnOrder", LazyChargemapTableColumnOrder],
["ChargemapTableRow", LazyChargemapTableRow],
["ChargemapTableRowSkeleton", LazyChargemapTableRowSkeleton],
["ChargemapDetailSection", LazyChargemapDetailSection],
["ChargemapDetailSectionContainer", LazyChargemapDetailSectionContainer],
["ChargemapDetailSectionLine", LazyChargemapDetailSectionLine],
["ChargemapFiltersContainer", LazyChargemapFiltersContainer],
["CheckboxFilter", LazyCheckboxFilter],
["FiltersSection", LazyFiltersSection],
["RadioFilter", LazyRadioFilter],
["RangeFilter", LazyRangeFilter],
["ChargemapLogo", LazyChargemapLogo],
["ChargemapPass", LazyChargemapPass],
["CommunityBlue", LazyCommunityBlue],
["CommunityWhite", LazyCommunityWhite],
["EmptyViewIllustration", LazyEmptyViewIllustration],
["LogoBusiness", LazyLogoBusiness],
["LogoOps", LazyLogoOps],
["LogoPartners", LazyLogoPartners],
["LogoPartnersMenu", LazyLogoPartnersMenu],
["NoContribution", LazyNoContribution],
["NoContributionWithFilters", LazyNoContributionWithFilters],
["PopupLocation", LazyPopupLocation],
["PopupMaterial", LazyPopupMaterial],
["PopupPrice", LazyPopupPrice],
["PopupSecurity", LazyPopupSecurity],
["BreadcrumbItem", LazyBreadcrumbItem],
["AppDownloadCta", LazyAppDownloadCta],
["AppDownloadSection", LazyAppDownloadSection],
["AuthWallDrawer", LazyAuthWallDrawer],
["B2CCheckbox", LazyB2CCheckbox],
["B2CSwitch", LazyB2CSwitch],
["BoostCtaBanner", LazyBoostCtaBanner],
["ChargemapAnnouncements", LazyChargemapAnnouncements],
["ChargemapB2CBadge", LazyChargemapB2CBadge],
["ChargemapB2CBadgeChip", LazyChargemapB2CBadgeChip],
["ChargemapB2CButton", LazyChargemapB2CButton],
["ChargemapB2CSlider", LazyChargemapB2CSlider],
["ChargemapB2CSwitch", LazyChargemapB2CSwitch],
["ChargemapBreadcrumbs", LazyChargemapBreadcrumbs],
["ChargemapCta", LazyChargemapCta],
["ChargemapFooter", LazyChargemapFooter],
["ChargemapFormInput", LazyChargemapFormInput],
["ChargemapMessageShort", LazyChargemapMessageShort],
["ChargemapMessageTall", LazyChargemapMessageTall],
["ChargemapNavigation", LazyChargemapNavigation],
["ChargemapPagination", LazyChargemapPagination],
["ChargemapSearchDropdown", LazyChargemapSearchDropdown],
["ChargemapSegmentedButton", LazyChargemapSegmentedButton],
["ChargemapSeparatedLabel", LazyChargemapSeparatedLabel],
["ChargingSession", LazyChargingSession],
["DiscoverChargemapPass", LazyDiscoverChargemapPass],
["EmptyView", LazyEmptyView],
["ExpenseReport", LazyExpenseReport],
["FooterMap", LazyFooterMap],
["JoinEvDrivers", LazyJoinEvDrivers],
["LanguageModal", LazyLanguageModal],
["MonthlyCharges", LazyMonthlyCharges],
["SegmentedButtonOption", LazySegmentedButtonOption],
["SelectMenu", LazySelectMenu],
["SelectMenuItem", LazySelectMenuItem],
["StepByStep", LazyStepByStep],
["SuperPartnerLabel", LazySuperPartnerLabel],
["FooterBottomLine", LazyFooterBottomLine],
["FooterCityFooter", LazyFooterCityFooter],
["FooterCityList", LazyFooterCityList],
["FooterDidomi", LazyFooterDidomi],
["FooterLocalesList", LazyFooterLocalesList],
["FooterMobileApps", LazyFooterMobileApps],
["FooterNetworkFooter", LazyFooterNetworkFooter],
["FooterNetworkList", LazyFooterNetworkList],
["FooterPrimaryFooter", LazyFooterPrimaryFooter],
["FooterSecondaryFooter", LazyFooterSecondaryFooter],
["FooterSocials", LazyFooterSocials],
["FormInputSearch", LazyFormInputSearch],
["FormInputSimple", LazyFormInputSimple],
["FormLabelledInput", LazyFormLabelledInput],
["FormSwitchSelector", LazyFormSwitchSelector],
["MapAddressSearch", LazyMapAddressSearch],
["MapFilter", LazyMapFilter],
["MapFiltersDiscountGroup", LazyMapFiltersDiscountGroup],
["MapFiltersPowerSelector", LazyMapFiltersPowerSelector],
["MapFiltersSelectorGrid", LazyMapFiltersSelectorGrid],
["MapRoutePanelCheckpointInput", LazyMapRoutePanelCheckpointInput],
["MapRoutePanelMobileAppBanner", LazyMapRoutePanelMobileAppBanner],
["MapRoutePanelRouteCreator", LazyMapRoutePanelRouteCreator],
["NavigationMenuButton", LazyNavigationMenuButton],
["SimulationBatteryLevel", LazySimulationBatteryLevel],
["SimulationConnectorCellPicker", LazySimulationConnectorCellPicker],
["SimulationConnectorsList", LazySimulationConnectorsList],
["SimulationCostLine", LazySimulationCostLine],
["SimulationLegalBlock", LazySimulationLegalBlock],
["SimulationPriceStructure", LazySimulationPriceStructure],
["SimulationResultsDisplay", LazySimulationResultsDisplay],
["SimulationResultsReducedDisplay", LazySimulationResultsReducedDisplay],
["SimulationResultsSummary", LazySimulationResultsSummary],
["SimulationUserSettings", LazySimulationUserSettings],
["SimulationVehicleCell", LazySimulationVehicleCell],
["SimulationVehiclesList", LazySimulationVehiclesList],
["VehiclesDeletionView", LazyVehiclesDeletionView],
["VehiclesFormView", LazyVehiclesFormView],
["VehiclesSelectorView", LazyVehiclesSelectorView],
["EmptyTableIcon", LazyEmptyTableIcon],
["InfoBanner", LazyInfoBanner],
["Loader", LazyLoader],
["ModerationTable", LazyModerationTable],
["ModerationTableLine", LazyModerationTableLine],
["Pagination", LazyPagination],
["Search", LazySearch],
["Select", LazySelect],
["DrawerCloseButton", LazyDrawerCloseButton],
["DrawerTitleBar", LazyDrawerTitleBar],
["BaseButton", LazyBaseButton],
["BasePagination", LazyBasePagination],
["BottomSheet", LazyBottomSheet],
["ChargemapAccordion", LazyChargemapAccordion],
["ChargemapBadge", LazyChargemapBadge],
["ChargemapBaseBadgeChip", LazyChargemapBaseBadgeChip],
["ChargemapCaption", LazyChargemapCaption],
["ChargemapCard", LazyChargemapCard],
["ChargemapDetailInfoLine", LazyChargemapDetailInfoLine],
["ChargemapDrawer", LazyChargemapDrawer],
["ChargemapDrawerContainer", LazyChargemapDrawerContainer],
["ChargemapFeedbackContainer", LazyChargemapFeedbackContainer],
["ChargemapLabel", LazyChargemapLabel],
["ChargemapMap", LazyChargemapMap],
["ChargemapMapDrawer", LazyChargemapMapDrawer],
["ChargemapMapFiltersContainer", LazyChargemapMapFiltersContainer],
["ChargemapMessage", LazyChargemapMessage],
["ChargemapModal", LazyChargemapModal],
["ChargemapPicturePreview", LazyChargemapPicturePreview],
["ChargemapSkeletonLoader", LazyChargemapSkeletonLoader],
["ChargemapTabs", LazyChargemapTabs],
["ConnectorsCarousel", LazyConnectorsCarousel],
["FileUploader", LazyFileUploader],
["ImageCropper", LazyImageCropper],
["ImageUploader", LazyImageUploader],
["MappyPoolPreview", LazyMappyPoolPreview],
["ModalBottomSheet", LazyModalBottomSheet],
["SimplifiedConnectorsCarousel", LazySimplifiedConnectorsCarousel],
["ChargemapFeedbacksFilter", LazyChargemapFeedbacksFilter],
["ChargemapGeneralMood", LazyChargemapGeneralMood],
["Feedback", LazyFeedback],
["FeedbackCard", LazyFeedbackCard],
["FeedbackRating", LazyFeedbackRating],
["FeedbacksNotFound", LazyFeedbacksNotFound],
["Checkin", LazyCheckin],
["CheckinContent", LazyCheckinContent],
["CheckinHeader", LazyCheckinHeader],
["CheckinInProgressContent", LazyCheckinInProgressContent],
["CheckinInProgressHeader", LazyCheckinInProgressHeader],
["Comment", LazyComment],
["CommentContent", LazyCommentContent],
["CommentHeader", LazyCommentHeader],
["CommentResponse", LazyCommentResponse],
["Report", LazyReport],
["ReportContent", LazyReportContent],
["ReportHeader", LazyReportHeader],
["LeafletRoutingMachine", LazyLeafletRoutingMachine],
["MapKey", LazyMapKey],
["MapZoom", LazyMapZoom],
["PhotoPanel", LazyPhotoPanel],
["PoolChargeSimulator", LazyPoolChargeSimulator],
["PoolListPanel", LazyPoolListPanel],
["PoolPrices", LazyPoolPrices],
["RoutePanel", LazyRoutePanel],
["PhotosPhotoDisplay", LazyPhotosPhotoDisplay],
["PoolListPreviewCard", LazyPoolListPreviewCard],
["PoolListPreviewCardHeader", LazyPoolListPreviewCardHeader],
["PreviewAssistanceTab", LazyPreviewAssistanceTab],
["PreviewConnectorsTab", LazyPreviewConnectorsTab],
["PreviewFeedbackTab", LazyPreviewFeedbackTab],
["PreviewInfoTab", LazyPreviewInfoTab],
["PreviewAssistanceAskForHelp", LazyPreviewAssistanceAskForHelp],
["PreviewAssistanceCompatibleWithPass", LazyPreviewAssistanceCompatibleWithPass],
["PreviewAssistanceOrderPass", LazyPreviewAssistanceOrderPass],
["PreviewAssistanceOwnerInfos", LazyPreviewAssistanceOwnerInfos],
["PreviewInfoDrawerInfoAccess", LazyPreviewInfoDrawerInfoAccess],
["PreviewInfoDrawerInfoAmenities", LazyPreviewInfoDrawerInfoAmenities],
["PreviewInfoDrawerInfoCard", LazyPreviewInfoDrawerInfoCard],
["PreviewInfoDrawerInfoDescription", LazyPreviewInfoDrawerInfoDescription],
["PreviewInfoDrawerInfoHours", LazyPreviewInfoDrawerInfoHours],
["PreviewInfoDrawerInfoNetwork", LazyPreviewInfoDrawerInfoNetwork],
["PreviewInfoDrawerOtherInfo", LazyPreviewInfoDrawerOtherInfo],
["PreviewHeaderActionsMenu", LazyPreviewHeaderActionsMenu],
["PreviewHeaderDrawerBadges", LazyPreviewHeaderDrawerBadges],
["PreviewHeaderDrawerHeader", LazyPreviewHeaderDrawerHeader],
["PreviewHeaderDrawerHeaderFree", LazyPreviewHeaderDrawerHeaderFree],
["PreviewHeaderDrawerHeaderPremium", LazyPreviewHeaderDrawerHeaderPremium],
["PreviewHeaderDrawerMessage", LazyPreviewHeaderDrawerMessage],
["PreviewHeaderDrawerPicturesContainer", LazyPreviewHeaderDrawerPicturesContainer],
["PreviewHeaderDrawerRating", LazyPreviewHeaderDrawerRating],
["PreviewHeaderDrawerReliabilityBar", LazyPreviewHeaderDrawerReliabilityBar],
["PreviewHeaderDrawerTitle", LazyPreviewHeaderDrawerTitle],
["ConnectorCard", LazyConnectorCard],
["ConnectorLine", LazyConnectorLine],
["PoolChargemapCompatibility", LazyPoolChargemapCompatibility],
["PoolPricesModal", LazyPoolPricesModal],
["FilterRatingRange", LazyFilterRatingRange],
["PoolRating", LazyPoolRating],
["RatingCriteriaPopup", LazyRatingCriteriaPopup],
["RatingDetailPopup", LazyRatingDetailPopup],
["RatingDetailPopupItem", LazyRatingDetailPopupItem],
["RatingInfosPopup", LazyRatingInfosPopup],
["ChargemapSpinningLoader", LazyChargemapSpinningLoader],
["IconAcademicCap", LazyIconAcademicCap],
["IconAdjustmentsHorizontal", LazyIconAdjustmentsHorizontal],
["IconAdjustmentsVertical", LazyIconAdjustmentsVertical],
["IconAirport", LazyIconAirport],
["IconAirportAlt", LazyIconAirportAlt],
["IconAnnotation", LazyIconAnnotation],
["IconArchive", LazyIconArchive],
["IconArchiveBox", LazyIconArchiveBox],
["IconArchiveBoxArrowDown", LazyIconArchiveBoxArrowDown],
["IconArchiveBoxXMark", LazyIconArchiveBoxXMark],
["IconArrayReturnRight", LazyIconArrayReturnRight],
["IconArrowCircleDown", LazyIconArrowCircleDown],
["IconArrowCircleLeft", LazyIconArrowCircleLeft],
["IconArrowCircleRight", LazyIconArrowCircleRight],
["IconArrowCircleUp", LazyIconArrowCircleUp],
["IconArrowDown", LazyIconArrowDown],
["IconArrowDownCircle", LazyIconArrowDownCircle],
["IconArrowDownLeft", LazyIconArrowDownLeft],
["IconArrowDownOnSquare", LazyIconArrowDownOnSquare],
["IconArrowDownOnSquareStack", LazyIconArrowDownOnSquareStack],
["IconArrowDownRight", LazyIconArrowDownRight],
["IconArrowDownTray", LazyIconArrowDownTray],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowLeftCircle", LazyIconArrowLeftCircle],
["IconArrowLeftEndOnRectangle", LazyIconArrowLeftEndOnRectangle],
["IconArrowLeftStartOnRectangle", LazyIconArrowLeftStartOnRectangle],
["IconArrowLongDown", LazyIconArrowLongDown],
["IconArrowLongLeft", LazyIconArrowLongLeft],
["IconArrowLongRight", LazyIconArrowLongRight],
["IconArrowLongUp", LazyIconArrowLongUp],
["IconArrowNarrowDouble", LazyIconArrowNarrowDouble],
["IconArrowNarrowDown", LazyIconArrowNarrowDown],
["IconArrowNarrowLeft", LazyIconArrowNarrowLeft],
["IconArrowNarrowRight", LazyIconArrowNarrowRight],
["IconArrowNarrowShortDown", LazyIconArrowNarrowShortDown],
["IconArrowNarrowShortUp", LazyIconArrowNarrowShortUp],
["IconArrowNarrowUp", LazyIconArrowNarrowUp],
["IconArrowPath", LazyIconArrowPath],
["IconArrowPathRoundedSquare", LazyIconArrowPathRoundedSquare],
["IconArrowRight", LazyIconArrowRight],
["IconArrowRightCircle", LazyIconArrowRightCircle],
["IconArrowRightEndOnRectangle", LazyIconArrowRightEndOnRectangle],
["IconArrowRightStartOnRectangle", LazyIconArrowRightStartOnRectangle],
["IconArrowSmallDown", LazyIconArrowSmallDown],
["IconArrowSmallLeft", LazyIconArrowSmallLeft],
["IconArrowSmallRight", LazyIconArrowSmallRight],
["IconArrowSmallRightLeft", LazyIconArrowSmallRightLeft],
["IconArrowSmallUp", LazyIconArrowSmallUp],
["IconArrowSmallUpDown", LazyIconArrowSmallUpDown],
["IconArrowTopRightOnSquare", LazyIconArrowTopRightOnSquare],
["IconArrowTrendingDown", LazyIconArrowTrendingDown],
["IconArrowTrendingUp", LazyIconArrowTrendingUp],
["IconArrowUp", LazyIconArrowUp],
["IconArrowUpCircle", LazyIconArrowUpCircle],
["IconArrowUpLeft", LazyIconArrowUpLeft],
["IconArrowUpOnSquare", LazyIconArrowUpOnSquare],
["IconArrowUpOnSquareStack", LazyIconArrowUpOnSquareStack],
["IconArrowUpRight", LazyIconArrowUpRight],
["IconArrowUpTray", LazyIconArrowUpTray],
["IconArrowUturnDown", LazyIconArrowUturnDown],
["IconArrowUturnLeft", LazyIconArrowUturnLeft],
["IconArrowUturnRight", LazyIconArrowUturnRight],
["IconArrowUturnUp", LazyIconArrowUturnUp],
["IconArrowsExpand", LazyIconArrowsExpand],
["IconArrowsPointingIn", LazyIconArrowsPointingIn],
["IconArrowsPointingOut", LazyIconArrowsPointingOut],
["IconArrowsRightLeft", LazyIconArrowsRightLeft],
["IconArrowsUpDown", LazyIconArrowsUpDown],
["IconAsterisk", LazyIconAsterisk],
["IconAtSymbol", LazyIconAtSymbol],
["IconAutocharge", LazyIconAutocharge],
["IconB2BParking", LazyIconB2BParking],
["IconB2BPlus", LazyIconB2BPlus],
["IconB2BTicket", LazyIconB2BTicket],
["IconBabyChanging", LazyIconBabyChanging],
["IconBackspace", LazyIconBackspace],
["IconBackward", LazyIconBackward],
["IconBadgeCheck", LazyIconBadgeCheck],
["IconBan", LazyIconBan],
["IconBankNotes", LazyIconBankNotes],
["IconBar3CenterLeft", LazyIconBar3CenterLeft],
["IconBars2", LazyIconBars2],
["IconBars3", LazyIconBars3],
["IconBars3BottomLeft", LazyIconBars3BottomLeft],
["IconBars3BottomRight", LazyIconBars3BottomRight],
["IconBars3CenterLeft", LazyIconBars3CenterLeft],
["IconBars4", LazyIconBars4],
["IconBarsArrowDown", LazyIconBarsArrowDown],
["IconBarsArrowUp", LazyIconBarsArrowUp],
["IconBattery0", LazyIconBattery0],
["IconBattery100", LazyIconBattery100],
["IconBattery50", LazyIconBattery50],
["IconBatteryHorizontal0", LazyIconBatteryHorizontal0],
["IconBatteryHorizontal10", LazyIconBatteryHorizontal10],
["IconBatteryHorizontal100", LazyIconBatteryHorizontal100],
["IconBatteryHorizontal25", LazyIconBatteryHorizontal25],
["IconBatteryHorizontal33", LazyIconBatteryHorizontal33],
["IconBatteryHorizontal50", LazyIconBatteryHorizontal50],
["IconBatteryHorizontal60", LazyIconBatteryHorizontal60],
["IconBatteryHorizontal80", LazyIconBatteryHorizontal80],
["IconBatteryVertical0", LazyIconBatteryVertical0],
["IconBatteryVertical10", LazyIconBatteryVertical10],
["IconBatteryVertical100", LazyIconBatteryVertical100],
["IconBatteryVertical25", LazyIconBatteryVertical25],
["IconBatteryVertical33", LazyIconBatteryVertical33],
["IconBatteryVertical50", LazyIconBatteryVertical50],
["IconBatteryVertical60", LazyIconBatteryVertical60],
["IconBatteryVertical80", LazyIconBatteryVertical80],
["IconBeaker", LazyIconBeaker],
["IconBell", LazyIconBell],
["IconBellAlert", LazyIconBellAlert],
["IconBellSlash", LazyIconBellSlash],
["IconBellSnooze", LazyIconBellSnooze],
["IconBolt", LazyIconBolt],
["IconBoltSlash", LazyIconBoltSlash],
["IconBookOpen", LazyIconBookOpen],
["IconBookmark", LazyIconBookmark],
["IconBookmarkAlt", LazyIconBookmarkAlt],
["IconBookmarkSlash", LazyIconBookmarkSlash],
["IconBookmarkSquare", LazyIconBookmarkSquare],
["IconBriefcase", LazyIconBriefcase],
["IconBugAnt", LazyIconBugAnt],
["IconBuildingLibrary", LazyIconBuildingLibrary],
["IconBuildingOffice", LazyIconBuildingOffice],
["IconBuildingOffice2", LazyIconBuildingOffice2],
["IconBuildingStorefront", LazyIconBuildingStorefront],
["IconBurger", LazyIconBurger],
["IconCaddie", LazyIconCaddie],
["IconCake", LazyIconCake],
["IconCalculator", LazyIconCalculator],
["IconCalendar", LazyIconCalendar],
["IconCalendarDays", LazyIconCalendarDays],
["IconCamera", LazyIconCamera],
["IconCameraPlus", LazyIconCameraPlus],
["IconCampside", LazyIconCampside],
["IconCar", LazyIconCar],
["IconCash", LazyIconCash],
["IconChargeStatusCharging", LazyIconChargeStatusCharging],
["IconChargeStatusPluggedCable", LazyIconChargeStatusPluggedCable],
["IconChargemap", LazyIconChargemap],
["IconChargemapBoost", LazyIconChargemapBoost],
["IconChargemapBusiness", LazyIconChargemapBusiness],
["IconChargemapPartners", LazyIconChargemapPartners],
["IconChargemapPass", LazyIconChargemapPass],
["IconChargesAtHome", LazyIconChargesAtHome],
["IconChargingBadge", LazyIconChargingBadge],
["IconChargingBadgeUnknown", LazyIconChargingBadgeUnknown],
["IconChargingStatusIcons", LazyIconChargingStatusIcons],
["IconChartBar", LazyIconChartBar],
["IconChartBarSquare", LazyIconChartBarSquare],
["IconChartPie", LazyIconChartPie],
["IconChartSquareBar", LazyIconChartSquareBar],
["IconChat", LazyIconChat],
["IconChatAlt", LazyIconChatAlt],
["IconChatAlt2", LazyIconChatAlt2],
["IconChatBubbleBottomCenter", LazyIconChatBubbleBottomCenter],
["IconChatBubbleBottomCenterText", LazyIconChatBubbleBottomCenterText],
["IconChatBubbleLeft", LazyIconChatBubbleLeft],
["IconChatBubbleLeftEllipsis", LazyIconChatBubbleLeftEllipsis],
["IconChatBubbleLeftRight", LazyIconChatBubbleLeftRight],
["IconChatBubbleOvalLeft", LazyIconChatBubbleOvalLeft],
["IconChatBubbleOvalLeftEllipsis", LazyIconChatBubbleOvalLeftEllipsis],
["IconCheck", LazyIconCheck],
["IconCheckBadge", LazyIconCheckBadge],
["IconCheckCircle", LazyIconCheckCircle],
["IconChevronDoubleDown", LazyIconChevronDoubleDown],
["IconChevronDoubleLeft", LazyIconChevronDoubleLeft],
["IconChevronDoubleRight", LazyIconChevronDoubleRight],
["IconChevronDoubleUp", LazyIconChevronDoubleUp],
["IconChevronDown", LazyIconChevronDown],
["IconChevronLeft", LazyIconChevronLeft],
["IconChevronRight", LazyIconChevronRight],
["IconChevronUp", LazyIconChevronUp],
["IconChevronUpDown", LazyIconChevronUpDown],
["IconChip", LazyIconChip],
["IconChurch", LazyIconChurch],
["IconCircleStack", LazyIconCircleStack],
["IconClipboard", LazyIconClipboard],
["IconClipboardCheck", LazyIconClipboardCheck],
["IconClipboardCopy", LazyIconClipboardCopy],
["IconClipboardDocument", LazyIconClipboardDocument],
["IconClipboardDocumentCheck", LazyIconClipboardDocumentCheck],
["IconClipboardDocumentList", LazyIconClipboardDocumentList],
["IconClipboardList", LazyIconClipboardList],
["IconClock", LazyIconClock],
["IconClose", LazyIconClose],
["IconCloud", LazyIconCloud],
["IconCloudArrowDown", LazyIconCloudArrowDown],
["IconCloudArrowUp", LazyIconCloudArrowUp],
["IconCloudDownload", LazyIconCloudDownload],
["IconCloudUpload", LazyIconCloudUpload],
["IconCo2", LazyIconCo2],
["IconCode", LazyIconCode],
["IconCodeBracket", LazyIconCodeBracket],
["IconCodeBracketSquare", LazyIconCodeBracketSquare],
["IconCog", LazyIconCog],
["IconCog6Tooth", LazyIconCog6Tooth],
["IconCog8Tooth", LazyIconCog8Tooth],
["IconCollection", LazyIconCollection],
["IconColorSwatch", LazyIconColorSwatch],
["IconCommandLine", LazyIconCommandLine],
["IconComputerDesktop", LazyIconComputerDesktop],
["IconCornerUpLeft", LazyIconCornerUpLeft],
["IconCpuChip", LazyIconCpuChip],
["IconCreditCard", LazyIconCreditCard],
["IconCross", LazyIconCross],
["IconCube", LazyIconCube],
["IconCubeTransparent", LazyIconCubeTransparent],
["IconCurrencyBangladeshi", LazyIconCurrencyBangladeshi],
["IconCurrencyDollar", LazyIconCurrencyDollar],
["IconCurrencyEuro", LazyIconCurrencyEuro],
["IconCurrencyPound", LazyIconCurrencyPound],
["IconCurrencyRupee", LazyIconCurrencyRupee],
["IconCurrencyYen", LazyIconCurrencyYen],
["IconCursorArrowRays", LazyIconCursorArrowRays],
["IconCursorArrowRipple", LazyIconCursorArrowRipple],
["IconCursorClick", LazyIconCursorClick],
["IconDashboard", LazyIconDashboard],
["IconDatabase", LazyIconDatabase],
["IconDeliveryPoint", LazyIconDeliveryPoint],
["IconDesktopComputer", LazyIconDesktopComputer],
["IconDeviceMobile", LazyIconDeviceMobile],
["IconDevicePhoneMobile", LazyIconDevicePhoneMobile],
["IconDeviceTablet", LazyIconDeviceTablet],
["IconDocument", LazyIconDocument],
["IconDocumentAdd", LazyIconDocumentAdd],
["IconDocumentArrowDown", LazyIconDocumentArrowDown],
["IconDocumentArrowUp", LazyIconDocumentArrowUp],
["IconDocumentChartBar", LazyIconDocumentChartBar],
["IconDocumentCheck", LazyIconDocumentCheck],
["IconDocumentDownload", LazyIconDocumentDownload],
["IconDocumentDuplicate", LazyIconDocumentDuplicate],
["IconDocumentInvoice", LazyIconDocumentInvoice],
["IconDocumentMagnifyingGlass", LazyIconDocumentMagnifyingGlass],
["IconDocumentMinus", LazyIconDocumentMinus],
["IconDocumentPlus", LazyIconDocumentPlus],
["IconDocumentRemove", LazyIconDocumentRemove],
["IconDocumentReport", LazyIconDocumentReport],
["IconDocumentSearch", LazyIconDocumentSearch],
["IconDocumentText", LazyIconDocumentText],
["IconDollar", LazyIconDollar],
["IconDoor", LazyIconDoor],
["IconDot", LazyIconDot],
["IconDotsCircleHorizontal", LazyIconDotsCircleHorizontal],
["IconDotsHorizontal", LazyIconDotsHorizontal],
["IconDotsVertical", LazyIconDotsVertical],
["IconDownload", LazyIconDownload],
["IconDrinks", LazyIconDrinks],
["IconDrop", LazyIconDrop],
["IconDropdown", LazyIconDropdown],
["IconDuplicate", LazyIconDuplicate],
["IconEditWhite", LazyIconEditWhite],
["IconElectricOutlet", LazyIconElectricOutlet],
["IconEllipsisHorizontal", LazyIconEllipsisHorizontal],
["IconEllipsisHorizontalCircle", LazyIconEllipsisHorizontalCircle],
["IconEllipsisVertical", LazyIconEllipsisVertical],
["IconEmojiHappy", LazyIconEmojiHappy],
["IconEmojiSad", LazyIconEmojiSad],
["IconEnter", LazyIconEnter],
["IconEnvelope", LazyIconEnvelope],
["IconEnvelopeOpen", LazyIconEnvelopeOpen],
["IconError", LazyIconError],
["IconEuro", LazyIconEuro],
["IconExclamation", LazyIconExclamation],
["IconExclamationCircle", LazyIconExclamationCircle],
["IconExclamationTriangle", LazyIconExclamationTriangle],
["IconExternalLink", LazyIconExternalLink],
["IconEye", LazyIconEye],
["IconEyeClosed", LazyIconEyeClosed],
["IconEyeDropper", LazyIconEyeDropper],
["IconEyeOff", LazyIconEyeOff],
["IconEyeSlash", LazyIconEyeSlash],
["IconFaceFrown", LazyIconFaceFrown],
["IconFaceSmile", LazyIconFaceSmile],
["IconFacebook", LazyIconFacebook],
["IconFastForward", LazyIconFastForward],
["IconFilm", LazyIconFilm],
["IconFilter", LazyIconFilter],
["IconFingerPrint", LazyIconFingerPrint],
["IconFire", LazyIconFire],
["IconFlag", LazyIconFlag],
["IconFlagCheckLeft", LazyIconFlagCheckLeft],
["IconFlagCheckRight", LazyIconFlagCheckRight],
["IconFlagRectangleAdd", LazyIconFlagRectangleAdd],
["IconFlagRectangleLeft", LazyIconFlagRectangleLeft],
["IconFlagRectangleRight", LazyIconFlagRectangleRight],
["IconFlagTriangleAdd", LazyIconFlagTriangleAdd],
["IconFlashliteOff", LazyIconFlashliteOff],
["IconFlashliteOn", LazyIconFlashliteOn],
["IconFleet", LazyIconFleet],
["IconFolder", LazyIconFolder],
["IconFolderAdd", LazyIconFolderAdd],
["IconFolderArrowDown", LazyIconFolderArrowDown],
["IconFolderDownload", LazyIconFolderDownload],
["IconFolderMinus", LazyIconFolderMinus],
["IconFolderOpen", LazyIconFolderOpen],
["IconFolderPlus", LazyIconFolderPlus],
["IconFolderRemove", LazyIconFolderRemove],
["IconForward", LazyIconForward],
["IconFunnel", LazyIconFunnel],
["IconGasStation", LazyIconGasStation],
["IconGif", LazyIconGif],
["IconGift", LazyIconGift],
["IconGiftTop", LazyIconGiftTop],
["IconGlobe", LazyIconGlobe],
["IconGlobeAlt", LazyIconGlobeAlt],
["IconGlobeAmericas", LazyIconGlobeAmericas],
["IconGlobeAsiaAustralia", LazyIconGlobeAsiaAustralia],
["IconGlobeEuropeAfrica", LazyIconGlobeEuropeAfrica],
["IconHand", LazyIconHand],
["IconHandRaised", LazyIconHandRaised],
["IconHandThumbDown", LazyIconHandThumbDown],
["IconHandThumbUp", LazyIconHandThumbUp],
["IconHashtag", LazyIconHashtag],
["IconHeart", LazyIconHeart],
["IconHelp", LazyIconHelp],
["IconHeroicShoppingBag", LazyIconHeroicShoppingBag],
["IconHighway", LazyIconHighway],
["IconHome", LazyIconHome],
["IconHomeModern", LazyIconHomeModern],
["IconHospital", LazyIconHospital],
["IconIdentification", LazyIconIdentification],
["IconInbox", LazyIconInbox],
["IconInboxArrowDown", LazyIconInboxArrowDown],
["IconInboxIn", LazyIconInboxIn],
["IconInboxStack", LazyIconInboxStack],
["IconInfo", LazyIconInfo],
["IconInfoCircle", LazyIconInfoCircle],
["IconInformationCircle", LazyIconInformationCircle],
["IconInstagram", LazyIconInstagram],
["IconKey", LazyIconKey],
["IconLanguage", LazyIconLanguage],
["IconLaunchGps", LazyIconLaunchGps],
["IconLibrary", LazyIconLibrary],
["IconLifebuoy", LazyIconLifebuoy],
["IconLightBulb", LazyIconLightBulb],
["IconLightningBolt", LazyIconLightningBolt],
["IconLightningBoltFast", LazyIconLightningBoltFast],
["IconLightningBoltVeryFast", LazyIconLightningBoltVeryFast],
["IconLink", LazyIconLink],
["IconLinkedin", LazyIconLinkedin],
["IconListBullet", LazyIconListBullet],
["IconLoader", LazyIconLoader],
["IconLocationMarker", LazyIconLocationMarker],
["IconLockClosed", LazyIconLockClosed],
["IconLockOpen", LazyIconLockOpen],
["IconLodging", LazyIconLodging],
["IconLogin", LazyIconLogin],
["IconLogout", LazyIconLogout],
["IconMagnifyingGlass", LazyIconMagnifyingGlass],
["IconMagnifyingGlassCircle", LazyIconMagnifyingGlassCircle],
["IconMagnifyingGlassMinus", LazyIconMagnifyingGlassMinus],
["IconMagnifyingGlassPlus", LazyIconMagnifyingGlassPlus],
["IconMail", LazyIconMail],
["IconMailOpen", LazyIconMailOpen],
["IconMap", LazyIconMap],
["IconMapPin", LazyIconMapPin],
["IconMegaphone", LazyIconMegaphone],
["IconMenu", LazyIconMenu],
["IconMenuAlt1", LazyIconMenuAlt1],
["IconMenuAlt2", LazyIconMenuAlt2],
["IconMenuAlt3", LazyIconMenuAlt3],
["IconMenuAlt4", LazyIconMenuAlt4],
["IconMicrophone", LazyIconMicrophone],
["IconMinus", LazyIconMinus],
["IconMinusCircle", LazyIconMinusCircle],
["IconMoneyCoins", LazyIconMoneyCoins],
["IconMoon", LazyIconMoon],
["IconMusicNote", LazyIconMusicNote],
["IconMusicalNote", LazyIconMusicalNote],
["IconNewspaper", LazyIconNewspaper],
["IconNoPass", LazyIconNoPass],
["IconNoSymbol", LazyIconNoSymbol],
["IconNotificationCheckCircle", LazyIconNotificationCheckCircle],
["IconNotificationExclamationCircle", LazyIconNotificationExclamationCircle],
["IconNotificationInfoCircle", LazyIconNotificationInfoCircle],
["IconNotificationTrashCircle", LazyIconNotificationTrashCircle],
["IconOfficeBuilding", LazyIconOfficeBuilding],
["IconOrder", LazyIconOrder],
["IconPaintBrush", LazyIconPaintBrush],
["IconPaperAirplane", LazyIconPaperAirplane],
["IconPaperClip", LazyIconPaperClip],
["IconPark", LazyIconPark],
["IconParking", LazyIconParking],
["IconPassActivated", LazyIconPassActivated],
["IconPassNotActivated", LazyIconPassNotActivated],
["IconPause", LazyIconPause],
["IconPauseCircle", LazyIconPauseCircle],
["IconPencil", LazyIconPencil],
["IconPencilAlt", LazyIconPencilAlt],
["IconPencilSquare", LazyIconPencilSquare],
["IconPerson", LazyIconPerson],
["IconPhone", LazyIconPhone],
["IconPhoneArrowDownLeft", LazyIconPhoneArrowDownLeft],
["IconPhoneArrowUpRight", LazyIconPhoneArrowUpRight],
["IconPhoneIncoming", LazyIconPhoneIncoming],
["IconPhoneMissedCall", LazyIconPhoneMissedCall],
["IconPhoneOutgoing", LazyIconPhoneOutgoing],
["IconPhoneXMark", LazyIconPhoneXMark],
["IconPhoto", LazyIconPhoto],
["IconPhotograph", LazyIconPhotograph],
["IconPiggyBank", LazyIconPiggyBank],
["IconPin", LazyIconPin],
["IconPlay", LazyIconPlay],
["IconPlayCircle", LazyIconPlayCircle],
["IconPlayPause", LazyIconPlayPause],
["IconPlug", LazyIconPlug],
["IconPlugAndCharge", LazyIconPlugAndCharge],
["IconPluggedCar", LazyIconPluggedCar],
["IconPlus", LazyIconPlus],
["IconPlusCircle", LazyIconPlusCircle],
["IconPolygone", LazyIconPolygone],
["IconPosition", LazyIconPosition],
["IconPower", LazyIconPower],
["IconPresentationChartBar", LazyIconPresentationChartBar],
["IconPresentationChartLine", LazyIconPresentationChartLine],
["IconPrinter", LazyIconPrinter],
["IconPublicRoad", LazyIconPublicRoad],
["IconPuzzle", LazyIconPuzzle],
["IconPuzzlePiece", LazyIconPuzzlePiece],
["IconQrcode", LazyIconQrcode],
["IconQuestionMarkCircle", LazyIconQuestionMarkCircle],
["IconQuestionMarkCircleB2B", LazyIconQuestionMarkCircleB2B],
["IconQueueList", LazyIconQueueList],
["IconRadar", LazyIconRadar],
["IconRadio", LazyIconRadio],
["IconReceiptPercent", LazyIconReceiptPercent],
["IconReceiptRefund", LazyIconReceiptRefund],
["IconReceiptTax", LazyIconReceiptTax],
["IconRectangleGroup", LazyIconRectangleGroup],
["IconRectangleStack", LazyIconRectangleStack],
["IconRedOctogone", LazyIconRedOctogone],
["IconRefresh", LazyIconRefresh],
["IconReply", LazyIconReply],
["IconRestaurant", LazyIconRestaurant],
["IconRestroom", LazyIconRestroom],
["IconRewind", LazyIconRewind],
["IconRocketLaunch", LazyIconRocketLaunch],
["IconRocketLightning", LazyIconRocketLightning],
["IconRoute", LazyIconRoute],
["IconRouteOff", LazyIconRouteOff],
["IconRss", LazyIconRss],
["IconSave", LazyIconSave],
["IconSaveAs", LazyIconSaveAs],
["IconScale", LazyIconScale],
["IconScissors", LazyIconScissors],
["IconSearch", LazyIconSearch],
["IconSearchCircle", LazyIconSearchCircle],
["IconSelector", LazyIconSelector],
["IconServer", LazyIconServer],
["IconServerStack", LazyIconServerStack],
["IconSettingsHorizontal", LazyIconSettingsHorizontal],
["IconSettingsVertical", LazyIconSettingsVertical],
["IconShare", LazyIconShare],
["IconShareAlt", LazyIconShareAlt],
["IconShieldCheck", LazyIconShieldCheck],
["IconShieldExclamation", LazyIconShieldExclamation],
["IconShop", LazyIconShop],
["IconShoppingBag", LazyIconShoppingBag],
["IconShoppingCart", LazyIconShoppingCart],
["IconSignal", LazyIconSignal],
["IconSignalSlash", LazyIconSignalSlash],
["IconSnacking", LazyIconSnacking],
["IconSortAscending", LazyIconSortAscending],
["IconSortDescending", LazyIconSortDescending],
["IconSparkles", LazyIconSparkles],
["IconSpeaker", LazyIconSpeaker],
["IconSpeakerWave", LazyIconSpeakerWave],
["IconSpeakerXMark", LazyIconSpeakerXMark],
["IconSpeakerphone", LazyIconSpeakerphone],
["IconSpeakerphoneCircle", LazyIconSpeakerphoneCircle],
["IconSquare2Stack", LazyIconSquare2Stack],
["IconSquare3Stack3D", LazyIconSquare3Stack3D],
["IconSquares2x2", LazyIconSquares2x2],
["IconSquaresPlus", LazyIconSquaresPlus],
["IconStar", LazyIconStar],
["IconStarEmpty", LazyIconStarEmpty],
["IconStarFull", LazyIconStarFull],
["IconStarHalf", LazyIconStarHalf],
["IconStatusOffline", LazyIconStatusOffline],
["IconStatusOnline", LazyIconStatusOnline],
["IconStop", LazyIconStop],
["IconStopCircle", LazyIconStopCircle],
["IconSuccess", LazyIconSuccess],
["IconSun", LazyIconSun],
["IconSuperPartner", LazyIconSuperPartner],
["IconSupport", LazyIconSupport],
["IconSwatch", LazyIconSwatch],
["IconSwitchHorizontal", LazyIconSwitchHorizontal],
["IconSwitchVertical", LazyIconSwitchVertical],
["IconTable", LazyIconTable],
["IconTableCells", LazyIconTableCells],
["IconTag", LazyIconTag],
["IconTelepeage", LazyIconTelepeage],
["IconTemplate", LazyIconTemplate],
["IconTerminal", LazyIconTerminal],
["IconThumbDown", LazyIconThumbDown],
["IconThumbUp", LazyIconThumbUp],
["IconTicket", LazyIconTicket],
["IconTollBadge", LazyIconTollBadge],
["IconTopRightOnSquare", LazyIconTopRightOnSquare],
["IconTouristAttraction", LazyIconTouristAttraction],
["IconTrainStation", LazyIconTrainStation],
["IconTranslate", LazyIconTranslate],
["IconTrash", LazyIconTrash],
["IconTrendingDown", LazyIconTrendingDown],
["IconTrendingUp", LazyIconTrendingUp],
["IconTriangleUp", LazyIconTriangleUp],
["IconTrophy", LazyIconTrophy],
["IconTruck", LazyIconTruck],
["IconTv", LazyIconTv],
["IconTwitter", LazyIconTwitter],
["IconUnlink", LazyIconUnlink],
["IconUpload", LazyIconUpload],
["IconUser", LazyIconUser],
["IconUserAdd", LazyIconUserAdd],
["IconUserCircle", LazyIconUserCircle],
["IconUserGroup", LazyIconUserGroup],
["IconUserMinus", LazyIconUserMinus],
["IconUserPlus", LazyIconUserPlus],
["IconUserRemove", LazyIconUserRemove],
["IconUsers", LazyIconUsers],
["IconVariable", LazyIconVariable],
["IconVideoCamera", LazyIconVideoCamera],
["IconVideoCameraSlash", LazyIconVideoCameraSlash],
["IconViewBoards", LazyIconViewBoards],
["IconViewColumns", LazyIconViewColumns],
["IconViewGrid", LazyIconViewGrid],
["IconViewGridAdd", LazyIconViewGridAdd],
["IconViewList", LazyIconViewList],
["IconViewfinderCircle", LazyIconViewfinderCircle],
["IconVolumeOff", LazyIconVolumeOff],
["IconVolumeUp", LazyIconVolumeUp],
["IconWallet", LazyIconWallet],
["IconWarning", LazyIconWarning],
["IconWifi", LazyIconWifi],
["IconWindow", LazyIconWindow],
["IconWorld", LazyIconWorld],
["IconWrench", LazyIconWrench],
["IconWrenchScrewdriver", LazyIconWrenchScrewdriver],
["IconX", LazyIconX],
["IconXCircle", LazyIconXCircle],
["IconXMark", LazyIconXMark],
["IconYoutube", LazyIconYoutube],
["IconZoomIn", LazyIconZoomIn],
["IconZoomOut", LazyIconZoomOut],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
